import React from 'react';
import { translate } from 'react-switch-lang';
import { TransactionDatatable } from '../../../_fragments/transactiondatatable';
import { ReturnService as service } from '../../../_services/transaction/asset.return.service';
import { Label } from 'semantic-ui-react';
import moment from 'moment';

const AssetReturn = (props) => {
  const { t } = props;
  const header = {
    icon: 'cubes',
    content: 'Asset Return',
    subHeader: 'Listing',
  };

  const insertBtn = {
    text: t('Add'),
    link: props.location.pathname + '/insert',
  };

  const actionPath = {
    add: `${props.location.pathname}/insert`,
    edit: `${props.location.pathname}/update`,
    delete: `${props.location.pathname}/delete`,
  };

  const headers = [
    { title: 'Code', field: 'Code' },
    {
      title: 'Date',
      field: 'Data',
      render: (rowData) => moment(rowData).format('DD/MM/YYYY'),
    },
    // { title: 'Return Type', field: 'OwnerTypeDesc' },
    { title: 'Return By', field: 'ReturnBy' },
    { title: 'Borrow No.', field: 'AssetBorrowCode' },
    {
      title: 'Status',
      field: 'Status',
      render: (rowData) => (
        <Label color={rowData.Status == 'APPROVE' ? 'green' : 'grey'}>
          {rowData.Status}
        </Label>
      ),
    },
    { title: 'Create By', field: 'CreateBy' },
    // { title: 'Create Date', field: 'CreateDate', type: 'date' },
  ];

  const title = 'Asset Return';
  const filenameXML = 'asset-return';
  const menuCode = 'M_ASSET_RETURN';
  return (
    <>
      <TransactionDatatable
        header={header}
        insertBtn={insertBtn}
        title={title}
        headers={headers}
        filenameXML={filenameXML}
        root={props.root}
        history={props.history}
        path={actionPath}
        service={service}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetReturn);
